import { contactEmails } from '../constants/contact-data';
import { world } from '../languages';

const contactEmail = (): string => contactEmails[world];

export default contactEmail;
